import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectRouteReloadKey } from 'Navigation/navigationSlice';

type Params = Record<string, string | undefined>;

function hashRecord(obj: Params) {
    const entries = Object.entries(obj)
        .filter(([, v]) => v !== undefined)
        .sort(([a], [b]) => a.localeCompare(b));

    const str = entries.map(([k, v]) => `${k}:${v}`).join('|');

    let hash = 0;
    const prime = 31;
    for (let i = 0; i < str.length; i++) {
        hash = (hash * prime + str.charCodeAt(i)) % 1_000_000_007;
    }

    return hash.toString(36);
}

// This hook returns a stable key alongside params so react2angular directives rerender on param changes.
export function useAngularToReactRoute<T extends Params = Params>(): [string, ReturnType<typeof useParams<T>>] {
    const params = useParams<T>();
    const routeReloadKey = useSelector(selectRouteReloadKey);
    const paramsHash = hashRecord(params);

    return [`${routeReloadKey}-${paramsHash}`, params];
}
